export default __webpack_public_path__ + "static/media/Abigail-Keel.24924d87.jpg";